<template>
    <div class="detail_body posi_rela">
        <div class="loading_bd flex_c" v-if="detailLoading">
            <div class="loading_con flex_c">
                <el-icon class="loading_size is-loading">
                    <Loading/>
                </el-icon>
                <div class="loading_text">数据加载中</div>
            </div>
        </div>
        <div class="patient_info_body">
            <div class="patient_info_bd">
                <div class="detail_info_line flex_c_between">
                    <div class="detail_font font1_2rem flex_c_left">
                        <span class="no_font">NO.</span><span class="no_num_font">{{ medicalOrder.serialNo }}</span>
                    </div>
                    <div class="detail_font status_font flex_c_right">
                            <span :class="medicalOrder.status === '1' || medicalOrder.status === '6' ? 'text-blue':
                            medicalOrder.status === '2' || medicalOrder.status === '5' ? 'text-orange':
                            medicalOrder.status === '3' || medicalOrder.status === '4' ? 'text-red':'text-grey1'">{{
                                    getOrderStatus(medicalOrder.status)
                                }}</span>
                    </div>
                </div>
                <div class="detail_info_line">
                    <div class="detail_font flex_c_left">
                        <span class="mrr20"><span class="font_gray">姓名：</span>{{ patientInfo.name }}</span>
                        <span class="mrr20"><span
                            class="font_gray">性别：</span>{{ patientInfo.sex === '0' ? '男' : patientInfo.sex === '1' ? '女' : '未知' }}</span>
                        <span class="mrr20"><span
                            class="font_gray">年龄：</span>{{ patientInfo.age === null ? '--' : patientInfo.age }}岁</span>
                        <span class="mrr20"><span
                            class="font_gray">联系电话：</span>{{ patientInfo.phoneNumber === null ? '无' : patientInfo.phoneNumber }}</span>
                    </div>
                </div>
                <div class="detail_info_line">
                    <div class="detail_font50 flex_c_left">
                        <span class="mrr20"><span
                            class="font_gray">身份证号码：</span>{{patientInfo.identity===null?"--":patientInfo.identity.substr(0,6) + '********' + patientInfo.identity.substr(14, 20)}}</span>
                    </div>
                    <div class="detail_font50 flex_c_left">
                        <span class="mrr20"><span
                            class="font_gray">联系地址：</span>{{ patientInfo.province === null ? '无' : patientInfo.province }}</span>
                    </div>
                </div>
            </div>
            <!-- 诊断信息沿用配送信息的字段排版，并展示当前订单的开方记录。 -->
            <div class="patient_info_bd">
                <div class="detail_info_line flex_c_between">
                    <div class="width100 name_font">诊断信息：</div>
                </div>
                <div class="detail_info_line flex_c_top flex_c_wrap">
                    <div class="detail_font100 flex_c_left">
                        <span class="font_gray">主诉：</span>{{ diagnosisText(medicalOrder.mainSuit) }}
                    </div>
                    <div class="detail_font100 flex_c_left">
                        <span class="font_gray">诊断：</span>{{ diagnosisText(medicalOrder.clinicalDiagnosis) }}
                    </div>
                    <div class="detail_font50 flex_c_left">
                        <span class="font_gray">既往史：</span>{{ diagnosisText(medicalOrder.patientMedicalHistory) }}
                    </div>
                    <div class="detail_font50 flex_c_left">
                        <span class="font_gray">现病史：</span>{{ diagnosisText(medicalOrder.nowMedicalHistory) }}
                    </div>
                    <div class="detail_font50 flex_c_left">
                        <span class="font_gray">过敏史：</span>{{ diagnosisText(medicalOrder.patientOperationHistory) }}
                    </div>
                    <div class="detail_font50 flex_c_left">
                        <span class="font_gray">检查记录：</span>{{ diagnosisText(medicalOrder.inspectionRecord) }}
                    </div>
                </div>
            </div>
            <div class="patient_info_bd">
                <div class="detail_info_line flex_c_between">
                    <div class="width100 name_font">RP：
                        <span
                            class="font_gold">{{
                                medicalOrder.billingType === '1' ? '饮片' : medicalOrder.billingType === '2' ? '膏方' : medicalOrder.billingType === '3' ? '水丸' : '颗粒'
                            }}</span>
                    </div>
                </div>
                <div class="detail_info_line">
                    <div class="med_list_con flex_left_warp">
                        <div class="med_list_li flex_c_between" v-for="(item, index) in medicalOrder.orderMedicineList"
                             :key="index">
                            <!-- 超量签章水印（左上角） -->
                            <div class="usage_sign_badge" v-if="item.isOverLimit">{{ item.usageSignName }}</div>
                            <!-- 超量提示（底部浮动） -->
                            <div class="usage_sign_remark" v-if="item.isOverLimit">{{ item.usageSignRemark }}</div>
                            <span class="font_gold"
                                  v-if="item.standard !== null && item.standard !== undefined && item.standard !== '' && (medicalOrder.billingType === '0' || medicalOrder.billingType === 0) && newRuleOpen">[{{
                                    item.standard
                                }}]</span>
                            <span class="med_li_name">{{ item.meName }}</span>
                            <span class="font_gold"
                                  v-if="item.drugProperty && item.drugProperty !== null && item.drugProperty !== undefined && item.drugProperty !== ''">({{
                                    item.drugProperty
                                }})</span>
                            <span class="font_gray"
                                  v-if="item.decoctionId && item.decoctionId !== null && item.decoctionId !== undefined && item.decoctionId !== '' && (medicalOrder.billingType !== '0' && medicalOrder.billingType !== 0) && item.decoctionName !== '无'">({{
                                    item.decoctionName
                                }})</span>
                            <span class="font_gray mrl10">{{ item.newGCount }}g</span>
                        </div>
                    </div>
                </div>
                <div class="detail_info_line flex_t_col"
                     v-if="medicalOrder.billingType === '2' && medicalOrder.orderMedicineFuList.length > 0">
                    <div class="detail_font flex_c_left">辅料：</div>
                    <div class="font_black">{{ showOrderMedicineFuList }}</div>
                </div>
            </div>
            <div class="patient_info_bd">
                <div class="detail_info_line flex_c_between">
                    <div class="detail_font flex_c_left">每剂 {{ medicalOrder.orderMedicineList.length }} 味药材，共
                        {{ medicalOrder.viceNum }} 剂
                    </div>
                    <div class="detail_font flex_c_left">
                        <span class="font_gray">药方总重：</span>
                        <span
                            class="detail_font_red">{{ getOrderWeightByNewGCount(medicalOrder.orderMedicineList) }}g</span>
                    </div>
                </div>
                <div class="detail_info_line flex_t_col">
                    <div class="detail_font flex_c_top">
                        <div class="f_left font_gray">用法：</div>
                        <div class="f_right">{{ medicalOrder.instructions }}</div>
                    </div>
                    <div class="detail_font flex_c_left"><span
                        class="font_gray">*每次服用袋数请参照随药寄送的贴纸说明</span></div>
                </div>
            </div>

            <!-- 费用明细-->
            <div class="patient_info_bd">
                <div class="detail_info_line flex_c_between">
                    <div class="width100 name_font">费用明细：</div>
                </div>
                <div class="detail_info_line flex_c_top flex_c_wrap">
                    <div class="detail_font50 flex_c_left" v-if="doctorInfo.docPriceHide === '0'">
                        <span class="font_gray">药材费用：</span>
                        <span class="detail_font_red">{{ medicalOrder.medicalCountPrice }}</span><span
                        class="font_gold">元</span>
                    </div>
                    <div class="detail_font50 flex_c_left" v-if="medicalOrder.billingType !== '0'"><span
                        class="font_gray">加工费用：</span>
                        <span
                            class="detail_font_red">{{
                                medicalOrder.processingCosts === null || medicalOrder.processingCosts === undefined ? '0.00' : medicalOrder.processingCosts
                            }}</span><span
                            class="font_gold">元</span>
                    </div>
                    <div class="detail_font50 flex_c_left" v-if="doctorInfo.docPriceHide === '0'"><span
                        class="font_gray">医生诊金：</span>
                        <span
                            class="detail_font_red">{{
                                medicalOrder.docPrice === null ? "0" : medicalOrder.docPrice
                            }}</span><span
                            class="font_gold">元</span>
                    </div>
                    <div class="detail_font50 flex_c_left" v-if="doctorInfo.docPriceHide === '0'"><span
                        class="font_gray">诊后病程管理费用：</span>
                        <span
                            class="detail_font_red">{{
                                medicalOrder.adjustmentPrice === null ? "0" : medicalOrder.adjustmentPrice
                            }}</span><span
                            class="font_gold">元</span>
                    </div>
<!--                    <div class="detail_font50 flex_c_left" v-if="doctorInfo.docPriceHide === '0'"><span-->
<!--                        class="font_gray">优惠金额：</span>-->
<!--                        <span-->
<!--                            class="detail_font_red">{{-->
<!--                                medicalOrder.discountPrice === null ? "0" : medicalOrder.discountPrice-->
<!--                            }}</span><span-->
<!--                            class="font_gold">元</span>-->
<!--                    </div>-->
                    <div class="detail_font50 flex_c_left" v-if="doctorInfo.docPriceHide === '0'"><span
                        class="font_gold">总金额：</span>
                        <span
                            class="detail_font_red">{{
                                medicalOrder.orderPrice === null ? "0" : medicalOrder.orderPrice
                            }}</span><span
                            class="font_gold">元</span>
                    </div>
                </div>
            </div>

            <!-- 药方配送 -->
            <div class="patient_info_bd">
                <div class="detail_info_line flex_c_between">
                    <div class="width100 name_font">配送信息：</div>
                </div>
                <div class="detail_info_line flex_c_top flex_c_wrap" v-if="medicalOrder.deliverWay === '0'">
                    <div class="detail_font50 flex_c_left">
                        <span class="font_gray">配送方式：</span>
                        <span>物流配送</span>
                    </div>
                    <div class="detail_font50 flex_c_left">
                        <span class="font_gray">物流公司：</span>
                        <span>{{medicalOrder.trackingCom === null ? '无':medicalOrder.trackingCom}}</span>
                    </div>
                    <div class="detail_font50 flex_c_left">
                        <span class="font_gray">收货信息：</span>
                        <span>{{medicalOrder.receivePersonName}}&nbsp;&nbsp;&nbsp;&nbsp;{{medicalOrder.receivePhone}}</span>
                    </div>
                    <div class="detail_font50 flex_c_left">
                        <span class="font_gray">物流单号：</span>
                        <span>{{medicalOrder.trackingNo === null ? '无':medicalOrder.trackingNo}}</span>
                    </div>
                    <div class="detail_font100 flex_c_left">
                        <span class="font_gray">配送地址：</span>
                        <span>{{medicalOrder.receiveProvince}}{{medicalOrder.receiveCity}}{{medicalOrder.receiveCountry}}{{medicalOrder.receiveAddress}}</span>
                    </div>
                </div>

                <div class="detail_info_line flex_c_top flex_c_wrap" v-if="medicalOrder.deliverWay === '1'">
                    <div class="detail_font100 flex_c_left">
                        <span class="font_gray">配送方式：</span>
                        <span>门诊自取</span>
                    </div>
                    <div class="detail_font100 flex_c_left">
                        <span class="font_gray">自取门诊：</span>
                        <span>二七知夏中医门诊部</span>
                    </div>
                    <div class="detail_font100 flex_c_left">
                        <span class="font_gray">门诊地址：</span>
                        <span>河南省郑州市二七区五里堡街道建设东路49号中投汇金城北门旁（导航搜索：知夏中医）</span>
                    </div>
                </div>
            </div>

            <!-- 其他信息 -->
            <div class="patient_info_bd">
                <div class="detail_info_line flex_c_between">
                    <div class="width100 name_font">其他信息：</div>
                </div>
                <div class="detail_info_line flex_c_top flex_c_wrap">
                    <div class="detail_font50 flex_c_left"><span class="font_gray">开方剂型：</span>
                        {{
                            medicalOrder.billingType === null || medicalOrder.billingType === '0' ? '颗粒' : medicalOrder.billingType === '1' ? '饮片' : medicalOrder.billingType === '2' ? '膏方' : '水丸'
                        }}
                    </div>
                    <div class="detail_font50 flex_c_left" v-if="medicalOrder.status !== '1'"><span
                        class="font_gray">开方时间：</span>{{
                            medicalOrder.createTime === null ? "---" : medicalOrder.createTime
                        }}
                    </div>
                    <div class="detail_font50 flex_c_left" v-if="medicalOrder.status !== '1'"><span
                        class="font_gray">接单时间：</span>{{
                            medicalOrder.receiveTime === null ? "---" : medicalOrder.receiveTime
                        }}
                    </div>
                    <div class="detail_font50 flex_c_left" v-if="medicalOrder.status === '5'"><span
                        class="font_gray">驳回时间：</span>{{
                            medicalOrder.rejectTime === null ? "---" : medicalOrder.rejectTime
                        }}
                    </div>
                    <div class="detail_font50 flex_c_left"
                         v-if="medicalOrder.status === '6' || medicalOrder.status === '7'">
                            <span
                                class="font_gray">支付时间：</span>{{
                            medicalOrder.payTime === null ? "---" : medicalOrder.payTime
                        }}
                    </div>
                    <div class="detail_font50 flex_c_left"
                         v-if="medicalOrder.status === '6' || medicalOrder.status === '7'">
                            <span
                                class="font_gray">发货时间：</span>{{
                            medicalOrder.deliverTime === null ? "---" : medicalOrder.deliverTime
                        }}
                    </div>
                    <div class="detail_font50 flex_c_left" v-if="medicalOrder.status === '7'">
                            <span
                                class="font_gray">收货时间：</span>{{
                            medicalOrder.completeTime === null ? "---" : medicalOrder.completeTime
                        }}
                    </div>
                    <div class="detail_font50 flex_c_left" v-if="medicalOrder.status === '8'">
                            <span
                                class="font_gray">取消时间：</span>{{
                            medicalOrder.cancelTime === null ? "---" : medicalOrder.cancelTime
                        }}
                    </div>
                    <div class="detail_font50 flex_c_left"><span
                        class="font_gray">开方备注：</span>{{
                            medicalOrder.remark === '' || medicalOrder.remark === null ? '无' : medicalOrder.remark
                        }}
                    </div>
                </div>
            </div>
        </div>
        <div class="patient_order_detail">
            <div class="detail_info_line flex_c_between">
                <div class="width100 name_font">总费用：<span
                    class="detail_font_red">{{ medicalOrder.orderPrice }}</span><span class="font_gold">元</span>
                </div>
                <div class="flex_c_right">
                    <!-- 订单收费入口暂时关闭，保留收费逻辑以便后续恢复。 -->
                    <!-- <el-button type="success" v-if="medicalOrder.status === '3'" @click="openPayScreen()">收费</el-button> -->
                    <el-button type="primary" @click="exportOrder">处方笺</el-button>
                    <el-button type="warning" @click="oneMoreOrder">再来一单</el-button>
                    <el-button type="warning" v-if="medicalOrder.status === '1' || medicalOrder.status === '3'"
                               @click="userEditOrder">修改
                    </el-button>
                    <el-button type="danger" v-if="medicalOrder.status === '1' || medicalOrder.status === '3'"
                               @click="userCancelOrder">作废
                    </el-button>
                </div>
            </div>
        </div>
    </div>

    <!-- 处方笺预览-->
    <el-dialog v-model="prescriptionPaperDialogDialogVisible" width="600px" center>
        <div class="prescriptionPaperDialog" id="printArea">
            <div class="paper_title_con">
                <div class="paper_title">知夏中医门诊部专用处方笺</div>
            </div>
            <div class="paper_line flex_c_col">
                <div class="width100 flex_c_between">
                    <span class="paper_line_left flex_c_left">姓名：{{patientInfo.name}}</span>
                    <span class="paper_line_left flex_c">性别：{{patientInfo.sex === '0' ? '男' : patientInfo.sex === '1' ? '女' : '未知'}}</span>
                    <span class="paper_line_left flex_c_right">年龄：{{patientInfo.age === null ? '--' : patientInfo.age}}岁</span>
                </div>
                <div class="width100 flex_c_between">
                    <div class="paper_line_left flex_c_left">
                        <span>处方号：{{medicalOrder.serialNo}}</span>
                    </div>
                    <div class="paper_line_left flex_c_right">
                        <span>日期：{{medicalOrder.createTime}}</span>
                    </div>
                </div>
            </div>
            <div class="paper_line flex_left_warp">
                <span>临床诊断：{{medicalOrder.clinicalDiagnosis === null ? '无' : medicalOrder.clinicalDiagnosis}}</span>
            </div>
            <div class="paper_line flex_t_col">
                <div class="detail_info_line flex_c_between">
                    <div class="width100" style="font-size: 18px;font-weight: bold">RP：
                        <span class="font_gold">{{ medicalOrder.billingType === '1' ? '饮片' : medicalOrder.billingType === '2' ? '膏方' : medicalOrder.billingType === '3' ? '水丸' : '颗粒' }}</span>
                    </div>
                </div>
                <div class="detail_info_line detail_con">
                    <div class="med_list_con flex_left_warp">
                        <div class="med_list_li flex_c_between" v-for="(item, index) in medicalOrder.orderMedicineList" :key="index">
                            <span class="med_li_name12">{{ item.meName }}</span>
                            <span class="font_gold"
                                  v-if="item.drugProperty !== null && item.drugProperty !== undefined && item.drugProperty !== ''">({{ item.drugProperty }})</span>
                            <span class="font_gray"
                                  v-if="item.decoctionId !== null && item.decoctionId !== undefined && item.decoctionId !== '' && item.decoctionName !== '无'">({{ item.decoctionName }})</span>
                            <span class="mrl10">{{ item.newGCount }}<span class="mrl5">g</span></span>
                        </div>
                    </div>
                </div>
                <div class="detail_info_line flex_t_col"
                     v-if="medicalOrder.billingType === '2' && medicalOrder.orderMedicineFuList.length > 0">
                    <div class="detail_font flex_c_left">辅料：</div>
                    <div class="font_black">{{ showOrderMedicineFuList }}</div>
                </div>
                <div class="detail_info_line flex_c_col">
                    <div class="mrt10 font_weight">{{ medicalOrder.instructions }}</div>
                    <div class="mrt10 font_weight">- - - - - 处方内容完毕 - - - - -</div>
                    <div class="mrt10">每剂 {{ medicalOrder.orderMedicineList.length }} 味药材，共{{ medicalOrder.viceNum }} 剂</div>
                </div>
            </div>
            <div class="paper_line paper_bottom_border flex_c_between">
                <div class="paper_ercode">
                    <el-image class="qrCode"
                              :src="tencentCosUrl+medicalOrder.payQrcode"
                              :zoom-rate="1.2"
                              :max-scale="7"
                              :min-scale="0.2" :hide-on-click-modal="true"
                              :preview-src-list="payCodeList"
                              fit="fill"
                    />
                    <div class="qrCode_info">扫码线上支付</div>
                </div>
                <!--            <div class="paper_ercode_right">-->
                <!--                <el-image class="qrCode" :src="tencentCosUrl+doctorInfo.qrCode" fit="fill"></el-image>-->
                <!--                <div class="qrCode_info">扫码关联医师</div>-->
                <!--            </div>-->
                <div class="paper_line_two flex_t_col">
                    <div class="paper_line_ifo flex_c_left"><span class="font_black">*每次服用袋数请参照随药寄送的贴纸说明</span></div>
<!--                    <div class="paper_line_ifo flex_c_left"><span class="font_black">药方总重：</span><span class="detail_font_gold">{{getOrderWeightByNewGCount(medicalOrder.orderMedicineList)}}</span>g</div>-->
                    <div class="paper_line_ifo flex_c_left"><span class="font_black">药方总费用：</span><span class="detail_font_red">{{ medicalOrder.orderPrice }}</span>元</div>
                </div>
            </div>
            <div class="paper_line flex_bot_between">
                <div class="paper_line_left_left flex_c_left">
                    <div class="paper_left">核对/发药：</div>
                    <div class="paper_right">
                        <span>{{medicalOrder.billingType === '0'?'知夏中医颗粒药房':'知夏中医饮片药房'}}</span>
                    </div>
                </div>
                <div class="paper_line_left flex_right_bottom">
                    <div class="paper_left">核发医师：</div>
                    <div class="paper_right">
                        <el-image style="height: 42px" :src="tencentCosUrl+doctorInfo.signPic" fit="cover"></el-image>
                    </div>
                </div>
            </div>
            <div class="paper_line_bot flex_c_between">
                <div class="paper_line_left flex_left_bottom">
                </div>
                <div class="paper_line_left flex_c_right">
                    <span>打印日期：{{printDate}}</span>
                </div>
            </div>
        </div>

        <template #footer >
            <div class="dialog-footer no-print">
                <el-button @click="cancelOrderPrint()">取消</el-button>
                <el-button type="primary" v-print="printInfoObj">打印</el-button>
            </div>
        </template>
    </el-dialog>

    <!-- 订单收费 -->
    <el-dialog
        v-model="orderPayDialogVisible"
        class="cashier-payment-modal"
        :before-close="cancalPay"
        :show-close="!payDialogLocked"
        :close-on-click-modal="!payDialogLocked"
        :close-on-press-escape="!payDialogLocked"
        title="订单收费"
        width="min(860px, calc(100vw - 32px))"
        align-center
    >
        <div class="pay_content flex_c_col cashier-payment-dialog">
            <PrescriptionGroupNotice :order-id="orderId" :visible="orderPayDialogVisible" :disabled="payDialogLocked || isWaitPayLoading" :refresh-key="`${payState}:${medicalOrder.payTime || ''}`" />
            <div class="cashier-payment-notice" role="note">
                <div><strong>本次收费：</strong>仅收取当前<span v-if="medicalOrder.serialNo"> {{ medicalOrder.serialNo }} </span>药方订单的费用，其他处方请逐张核对、分别办理。</div>
                <div><strong>付款核对：</strong>已付款订单请勿重复收费；患者表示已付款但系统未同步时，请先核对实际到账和收款记录。</div>
            </div>
            <div class="pay_main_body flex_t_col">
                <div class="pay_screen_con flex_c_col" v-if="isWaitPayLoading && !payLoading && !isPayed" role="status" aria-live="polite">
                    <div class="cashier-wait-panel"><el-icon class="cashier-wait-icon"><Connection /></el-icon><div class="cashier-wait-title">请扫描患者付款码</div><div class="cashier-wait-description">请患者打开微信或支付宝付款码，使用收钱吧盒子扫描。</div><div class="cashier-wait-note">扫码后将自动确认支付结果，请勿重复扫码或重复收费。</div></div>
                </div>
                <div class="pay_loading_con flex_c_col" v-if="payLoading && !isPayed" role="status" aria-live="polite" aria-busy="true">
                    <div class="cashier-wait-panel"><el-icon class="cashier-wait-icon is-loading"><Loading /></el-icon><div class="cashier-wait-title">正在确认支付结果</div><div class="cashier-wait-description">付款码已提交，正在查询收款结果，请耐心等待。</div><div class="cashier-wait-note">请勿关闭弹窗、重复扫码或再次收费，确认结果后会自动更新。</div></div>
                </div>
                <div class="cashier-order-loading" v-if="!isPayed && detailLoading">正在核对当前订单信息，加载完成后方可缴费。</div>
                <div class="pay_order_main cashier-entry" v-if="!isWaitPayLoading && !payLoading && !isPayed && !detailLoading">
                    <section class="cashier-block cashier-patient-block" aria-label="核对患者与处方">
                        <!-- 患者摘要沿用收费系统的上标下值布局，不增加重复标题。 -->
                        <div class="pay_info_item flex_c_between"><div class="pay_info_item_left">患者信息：</div><div class="pay_info_item_right cashier-patient-summary"><strong class="cashier-patient-name">{{ patientInfo.name }}</strong><span>{{ patientInfo.sex === '0' ? '男' : patientInfo.sex === '1' ? '女' : '未知' }}</span><span>{{ patientInfo.age === null ? '--' : patientInfo.age }}岁</span></div></div>
                        <div class="pay_info_item flex_c_between"><div class="pay_info_item_left">药方单号：</div><div class="pay_info_item_right">{{ medicalOrder.serialNo }}</div></div>
                        <div class="pay_info_item flex_c_between"><div class="pay_info_item_left">身份证号：</div><div class="pay_info_item_right">{{ !patientInfo.identity ? '--' : patientInfo.identity.substr(0, 6) + '********' + patientInfo.identity.substr(14, 20) }}</div></div>
                    </section>
                    <section class="cashier-block cashier-fee-block" aria-label="核对本单费用">
                        <div class="pay_info_title">核对本单费用<span class="cashier-section-hint">仅收当前药方</span></div>
                        <div class="pay_info_item flex_c_between">
                            <div class="pay_info_item_left">医生诊金（元）</div>
                            <div class="pay_info_item_right">{{ formatCashierAmount(medicalOrder.docPrice) }}</div>
                        </div>
                        <div class="pay_info_item flex_c_between">
                            <div class="pay_info_item_left">加工费用（元）</div>
                            <div class="pay_info_item_right">{{ formatCashierAmount(medicalOrder.processingCosts) }}</div>
                        </div>
                        <div class="pay_info_item flex_c_between cashier-amount-row">
                            <div class="pay_info_item_left">订单实付（元）</div>
                            <div class="pay_info_item_right">{{ formatCashierAmount(medicalOrder.orderPrice) }}</div>
                        </div>
                    </section>
                    <section class="cashier-block pay_method_section">
                        <div class="pay_info_title">选择方式并缴费<span class="cashier-section-hint">核对金额 → 选择方式 → 确定缴费</span></div>
                        <el-radio-group v-model="paymentMethod" class="pay_method_options" :disabled="payDialogLocked || isWaitPayLoading || manualPaymentUncertain || medicalOrder.status !== '3' || !['clinic', 'clinicRepeat'].includes(medicalOrder.orderSource)" aria-label="支付方式">
                            <el-radio label="SQB" class="pay_method_card"><CashierPaymentMethod method="SQB" /></el-radio>
                            <el-radio label="SELF_SCAN" class="pay_method_card"><CashierPaymentMethod method="SELF_SCAN" /></el-radio>
                            <el-radio label="CASH" class="pay_method_card"><CashierPaymentMethod method="CASH" /></el-radio>
                        </el-radio-group>
                        <div class="pay_method_hint" role="status">{{ paymentMethodHint }}</div>
                        <div class="cashier-order-loading" v-if="!['clinic', 'clinicRepeat'].includes(medicalOrder.orderSource) || medicalOrder.status !== '3'">当前订单不符合门诊收费条件，请核对订单来源及支付状态。</div>
                        <div class="cashier-order-loading" v-if="manualPaymentUncertain">收款结果尚未确认，请核对实际到账记录和订单状态，勿重复收费。</div>
                    </section>
                </div>
                <div class="pay_order_main cashier-block cashier-result-block" v-if="!isWaitPayLoading && isPayed">
                    <div class="pay_order_success flex_c_col">
                        <div class="cashier-result-heading"><el-icon class="pay_order_success_icon font_green" v-if="payState === 'success'"><SuccessFilled /></el-icon><el-icon class="pay_order_success_icon font_orange" v-if="payState === 'pending'"><WarningFilled /></el-icon><el-icon class="pay_order_success_icon font_red" v-if="payState === 'failed'"><CircleCloseFilled /></el-icon><div class="pay_order_success_text"><strong :class="{'cashier-result-status-pending': payState === 'pending', 'cashier-result-status-failed': payState === 'failed'}">{{ payResultText }}</strong><span>{{ patientInfo.name || '患者' }}的药方订单收款信息</span></div></div>
                        <div class="pay_order_error_text flex_c font_14" v-if="(payState !== 'success' || payChannel === 'MANUAL') && payErrorMsg">{{ payErrorMsg }}</div>
                        <section class="cashier-result-summary" aria-label="收款结果摘要"><div class="cashier-result-summary-item"><span>药方单号</span><strong>{{ medicalOrder.serialNo || '--' }}</strong></div><div class="cashier-result-summary-item" v-if="successPayed"><span>支付方式</span><strong>{{ payChannel === 'MANUAL' ? '已收款，渠道待核实' : payChannelText }}</strong></div><div class="cashier-result-summary-item" v-if="successPayed"><span>支付时间</span><strong>{{ medicalOrder.payTime || '--' }}</strong></div></section>
                        <section class="cashier-result-fee" aria-label="收款金额"><div class="cashier-result-fee-title">{{ payState === 'success' ? (payChannel === 'FREE' ? '本单金额（无需支付）' : '本次实收金额') : '订单金额' }}</div><div class="cashier-result-total" :class="{'cashier-result-status-pending': payState === 'pending', 'cashier-result-status-failed': payState === 'failed'}">￥{{ formatCashierAmount(medicalOrder.orderPrice) }}</div><div class="cashier-result-fee-detail"><span>医生诊金 ￥{{ formatCashierAmount(medicalOrder.docPrice) }}</span><span>加工费用 ￥{{ formatCashierAmount(medicalOrder.processingCosts) }}</span></div></section>
                        <div class="pay_warning_info flex_t_col"><div class="pay_warning_li" v-if="payDialogLocked">正在查询支付结果，请勿关闭弹窗。</div><div class="pay_warning_li" v-if="payState === 'pending'">支付结果尚未确认，请勿重复扫码，点击“重新查询”确认结果。</div><div class="pay_warning_li" v-else-if="payState === 'failed'">支付未完成，请点击“刷新重试”，重新核对支付方式后缴费。</div><div class="pay_warning_li" v-else-if="payState === 'success' && payChannel === 'FREE'">本单无需收款，请勿按已收款订单打印凭证。</div><div class="pay_warning_li" v-else-if="payState === 'success'">订单已登记收款；需要凭证时可通过收费系统查询并打印。</div></div>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <div class="dialog-footer">
                <el-button type="success" v-if="!isPayed && !isWaitPayLoading" :loading="payRequesting" :disabled="!canConfirmPayment" @click="confirmOrderPayment">确定缴费</el-button>
                <el-button type="warning" :loading="querying" v-if="isPayed && payState === 'pending'" @click="requeryPayResult()">重新查询</el-button>
                <el-button type="danger" v-if="isPayed && payState === 'failed'" @click="cancalOrRefreshPay()">刷新重试</el-button>
<!--                <el-button type="success" v-if="isPayed && successPayed" onclick="printPayed()">打印小票</el-button>-->
<!--                <el-button type="primary" v-if="!isPayed" @click="printPayInfo()">打印单据</el-button>-->
                <el-button type="info" @click="cancalPay()">关闭</el-button>
            </div>
        </template>
    </el-dialog>

</template>

<script>
import orderdetail from "@/assets/scripts/components/orderdetail";
import CashierPaymentMethod from "@/components/CashierPaymentMethod.vue";

export default {
    ...orderdetail,
    name: 'ClinicOrderDetail',
    components: {...orderdetail.components, CashierPaymentMethod},
    methods: {
        ...orderdetail.methods,
        // 只格式化收费展示金额，不参与业务金额计算。
        formatCashierAmount(value) {
            const amount = Number(value);
            return Number.isFinite(amount) ? amount.toFixed(2) : '0.00';
        }
    }
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/style.scss";
</style>
